import { request, METHOD } from '@/utils/request.js'




// 查询成绩
export function smallStudentScore(data) {
  return request(
    'h5Mfitness/teacher/smallStudentScore',
    METHOD.POST,
    data
  )
}


// 查看是否有准考证
export function checkOrder(data) {
  return request(
    '/h5Mfitness/parent/checkOrder',
    METHOD.POST,
    data
  )
}

//查看学生成绩
export function getScoreBySnCode(data) {
    return request(
      '/h5Mfitness/teacher/getScoreListBySnCode',
      METHOD.POST,
      data
    )
  }

  // 项目成绩详情
  export function getProjectScoreList(data) {
    return request(
      '/h5Mfitness/parent/getProjectScoreList',
      METHOD.POST,
      data
    )
  }  
    // 查询班级
    export function getClassInfoList(data) {
        return request(
          '/h5Mfitness/teacher/getClassInfoList',
          METHOD.POST,
          data
        )
      }  

       // 根据条件查询学生信息
    export function getStudentInfoList(data) {
        return request(
          '/h5Mfitness/teacher/getStudentInfoList',
          METHOD.POST,
          data
        )
      }  
           // 提交成绩
    export function submitScore(data) {
      return request(
        '/h5Mfitness/teacher/submitScore',
        METHOD.POST,
        data
      )
    }  
      